<div class="tips-container">
    <span>{{label}}</span>
    <mat-icon svgIcon="tips"></mat-icon>
</div>

